export default {
  adyenInputsWrapperSpan: Styles.color.grey.one,
};
